/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, w) {
	'use strict';
	/* globals Tc, debug */

	/**
	 * Module for last visited help pages component.
	 *
	 * @author Branislav Maksin
	 * @namespace Tc.Module
	 * @class LastVisitedHelpPages
	 * @extends Tc.Module
	 */
	Tc.Module.LastVisitedHelpPages = Tc.Module.extend({

		/**
		 * Main function.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			// First check if browser support localStorage
			if (typeof(w.localStorage) === "undefined") {
				return false;
			}

			//Do last visited pages
			mod.doLastVisitedPages();

			callback();
		},


		/**
		 * Check if last visited pages exist and display content
		 */
		doLastVisitedPages: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$data;

			// Get the current page URL and make it available to everyone in this module
			mod.getCurrentURL();

			// Now check if we have a data
			$data = w.localStorage.getItem('scsLastVisitedPages');
			if ($data !== null) {
				$data = JSON.parse($data);
				$data = mod.updateComponentDiv($data);

				// Check do we need to store this url
				if ($ctx.closest('body').data('url-save')) {
					mod.checkLinksCount($data);
				}
			} else {
				// Check do we need to store this url
				if ($ctx.closest('body').data('url-save')) {
					mod.processURL({'scsLastVisitedLinks': []});
				}
			}
		},

		/**
		 * Get current page URL without tabs and other selectors in it
		 *
		 * @return $pageUrl {String} Current page URL
		 */
		getCurrentURL: function () {
			var mod = this,
				$pathname = w.location.pathname,
				$pathnameParts = $pathname.split('.');

			// Remove tabs and other selectors from pathname
			$pathname = $pathnameParts[0] + '.' + $pathnameParts[$pathnameParts.length - 1];
			mod.currentURL = w.location.protocol + '//' + w.location.hostname + $pathname;
		},

		/**
		 * Insert link list into component
		 *
		 * @param data {JSON} value from storage
		 *
		 * @return data {JSON} Processed data
		 */
		updateComponentDiv: function (data) {
			var mod = this,
				$ctx = mod.$ctx,
				dataItems = data.scsLastVisitedLinks,
				dataList = '<ul class="link-list">',
				i = 0;

			// Do we have proper data
			if (dataItems.length <= 4) {

				// Create list of data
				for (i; i < dataItems.length; i++) {
					if (dataItems[i].url === mod.currentURL) {
						dataItems.splice(i, 1);
						i--;
					} else {
						dataList += '<li class="item-' + i + '"><a href="' + dataItems[i].url + '">' + dataItems[i].title + '</a></li>';
					}
				}

				// Now check if we have any items to show after data iteration
				if (dataItems.length > 0) {

					// We are creating list elements this way because it's global fastest way
					// http://jsperf.com/jquery-element-creationyay/19
					$(dataList + '</ul>').appendTo($ctx);

					// Show module element
					$ctx.show();
				}

			} else {
				debug.log('Tc.Module.LastVisitedHelpPages.js > Storage returned more then 4 items');
			}

			// Return new data
			return data;
		},

		/**
		 * Check if for some strange reason we are having more than 3 items in data
		 * We are doing this because previous function should remove unnecessary URL from it
		 *
		 * @param data {JSON} value
		 */
		checkLinksCount: function (data) {
			var mod = this;

			// Trim it to first 3
			if (data.scsLastVisitedLinks.length > 3) {
				data.scsLastVisitedLinks.splice(3);
			}

			// Proceed to processing URL of the current page
			mod.processURL(data);
		},

		/**
		 * Insert current URL into data at first place
		 *
		 * @param data {JSON} value
		 */
		processURL: function (data) {
			var mod = this,
				$ctx = mod.$ctx,
				$pageTitle = document.title.split('|'),
				$pageData = {},

			// Set new link item
				$pageData = {
					url: mod.currentURL,
					title: $.trim($pageTitle[0])
				};

			// And add it to the data
			data.scsLastVisitedLinks.unshift($pageData);

			// Add URLs to localStorage
			w.localStorage.setItem('scsLastVisitedPages', JSON.stringify(data));
		}
	});
})(Tc.$, window);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/modules/Tc.Module.LastVisitedHelpPages.js
// module id = 354
// module chunks = 0